import { z } from 'zod';

import { AbstractMeasurement } from './AbstractMeasurement';

const units = ['%'] as const;

const validator = AbstractMeasurement.value
    .extend({
        unit: z.literal('%').default('%'),
    })
    .default({});

export const Accuracy = {
    validator,
    units,
};

export type Accuracy = z.infer<typeof validator>;
